import { Component, OnInit, ViewChild, ɵSWITCH_CHANGE_DETECTOR_REF_FACTORY__POST_R3__ } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { GetSetsService } from '../get-sets.service';
import { SetDataScryfall, checklistEntry } from '../setData';

const checklistDataArray: checklistEntry[] = [
  {code: 'ecl', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'tla', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'spm', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'eoe', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'fin', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'tdm', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'dft', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'inr', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'fdn', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'dsk', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true},
  {code: 'blb', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, jpChecklist: true},
  {code: 'mh3', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'otj', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'mkm', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, ptChecklist: true, cnsChecklist: true},
  {code: 'rvr', deChecklist: true, enChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'lci', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'woe', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'ltr', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'mom', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'one', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'dmr', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'bro', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'dmu', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, cnsChecklist: true},
  {code: '2x2', deChecklist: true, enChecklist: true, frChecklist: true, jpChecklist: true, cnsChecklist: true},
  {code: 'clb', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, ptChecklist: true, jpChecklist: true, krChecklist: true, cntChecklist: true, cnsChecklist: true},
  {code: 'snc', deChecklist: true, enChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, jpChecklist: true, cntChecklist: true, cnsChecklist: true},
  {code: 'neo', deChecklist: false, enChecklist: true},
  {code: 'vow', deChecklist: true, enChecklist: true},
  {code: 'mid', deChecklist: true, enChecklist: true},
  {code: 'afr', deChecklist: true, enChecklist: true, itChecklist: true, frChecklist: true},
  {code: 'mh2', deChecklist: false, enChecklist: true},
  {code: 'stx', deChecklist: true, enChecklist: true},
  {code: 'tsr', deChecklist: true, enChecklist: true},
  {code: 'khm', deChecklist: true, enChecklist: true, frChecklist: true},
  {code: 'znr', deChecklist: true, enChecklist: true, frChecklist: true},
  {code: '2xm', deChecklist: false, enChecklist: false, notes: "did it exist?"},
  {code: 'm21', deChecklist: true, enChecklist: true, frChecklist: true},
  {code: 'iko', deChecklist: true, enChecklist: true, frChecklist: true},
  {code: 'thb', deChecklist: true, enChecklist: true, ruChecklist: true},
  {code: 'eld', deChecklist: true, enChecklist: true},
  {code: 'm20', deChecklist: true, enChecklist: true},
  {code: 'mh1', deChecklist: true, enChecklist: true},
  {code: 'war', deChecklist: true, enChecklist: true},
  {code: 'rna', deChecklist: true, enChecklist: true},
  {code: 'uma', deChecklist: false, enChecklist: true},
  {code: 'grn', deChecklist: true, enChecklist: true},
  {code: 'm19', deChecklist: true, enChecklist: true},
  {code: 'dom', deChecklist: false, enChecklist: true},
  {code: 'a25', deChecklist: false, enChecklist: false, notes: "did it exist?"},
  {code: 'rix', deChecklist: false, enChecklist: true},
  {code: 'ima', deChecklist: false, enChecklist: false, notes: "it existed: https://archive.is/HSNGx"},
  {code: 'xln', deChecklist: false, enChecklist: true},
  {code: 'hou', deChecklist: false, enChecklist: true},
  {code: 'akh', deChecklist: false, enChecklist: true},
  {code: 'mm3', deChecklist: false, enChecklist: true},
  {code: 'aer', deChecklist: false, enChecklist: true},
  {code: 'kld', deChecklist: true, enChecklist: true},
  {code: 'emn', deChecklist: false, enChecklist: true},
  {code: 'ema', deChecklist: false, enChecklist: true},
  {code: 'soi', deChecklist: false, enChecklist: true},
  {code: 'ogw', deChecklist: false, enChecklist: true},
  {code: 'bfz', deChecklist: false, enChecklist: true},
  {code: 'ori', deChecklist: true, enChecklist: true},
  {code: 'mm2', deChecklist: false, enChecklist: true},
  {code: 'dtk', deChecklist: false, enChecklist: true},
  {code: 'frf', deChecklist: false, enChecklist: true},
  {code: 'ktk', deChecklist: true, enChecklist: true},
  {code: 'm15', deChecklist: true, enChecklist: true},
  {code: 'jou', deChecklist: true, enChecklist: true},
  {code: 'bng', deChecklist: true, enChecklist: true},
  {code: 'ths', deChecklist: true, enChecklist: true},
  {code: 'm14', deChecklist: true, enChecklist: true},
  {code: 'mma', enChecklist: true},
  {code: 'dgm', deChecklist: true, enChecklist: true},
  {code: 'gtc', deChecklist: true, enChecklist: true},
  {code: 'rtr', deChecklist: true, enChecklist: true},
  {code: 'm13', deChecklist: true, enChecklist: true},
  {code: 'avr', deChecklist: true, enChecklist: true},
  {code: 'dka', deChecklist: true, enChecklist: true},
  {code: 'isd', deChecklist: true, enChecklist: true},
  {code: 'm12', deChecklist: true, enChecklist: true},
  {code: 'nph', deChecklist: true, enChecklist: true},
  {code: 'mbs', deChecklist: true, enChecklist: true},
  {code: 'som', deChecklist: true, enChecklist: true},
  {code: 'm11', deChecklist: true, enChecklist: true},
  {code: 'roe', deChecklist: true, enChecklist: true},
  {code: 'wwk', deChecklist: true, enChecklist: true},
  {code: 'zen', deChecklist: true, enChecklist: true},
  {code: 'm10', deChecklist: true, enChecklist: true},
  {code: 'arb', deChecklist: true, enChecklist: true, notes: "combined with Conflux"},
  {code: 'con', deChecklist: true, enChecklist: true},
  {code: 'ala', deChecklist: true, enChecklist: true},
  {code: 'eve', deChecklist: true, enChecklist: true},
  {code: 'shm', deChecklist: true, enChecklist: true},
  {code: 'mor', deChecklist: true, enChecklist: true},
  {code: 'lrw', deChecklist: true, enChecklist: true},
  {code: '10e', enChecklist: true},
  {code: 'fut', enChecklist: true, notes: "combined with Planar Chaos"},
  {code: 'plc', enChecklist: true},
  {code: 'tsp', deChecklist: true, enChecklist: true},
  {code: 'csp', deChecklist: true, enChecklist: true},
  {code: 'dis', deChecklist: true, enChecklist: true},
  {code: 'gpt', enChecklist: true},
  {code: 'rav', enChecklist: true, deChecklist: true},
  {code: '9ed', enChecklist: true},
  {code: 'sok', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, ptChecklist: true, itChecklist: true},
  {code: 'bok', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, ptChecklist: true, itChecklist: true},
  {code: 'chk', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, ptChecklist: true, itChecklist: true},
  {code: '5dn', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, ptChecklist: true, itChecklist: true},
  {code: 'dst', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, ptChecklist: true, itChecklist: true},
  {code: 'mrd', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, ptChecklist: true, itChecklist: true},
  {code: '8ed', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, ptChecklist: true, itChecklist: true},
  {code: 'scg', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, ptChecklist: true},
  {code: 'lgn', enChecklist: true, deChecklist: true, frChecklist: true, itChecklist: true, ptChecklist: true, esChecklist: true, jpChecklist: true},
  {code: 'ons', enChecklist: true, deChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, cnsChecklist: true, cntChecklist: true},
  {code: 'jud', enChecklist: true, deChecklist: true, frChecklist: true, esChecklist: true, itChecklist: true, ptChecklist: true},
  {code: 'tor', enChecklist: true, deChecklist: true, frChecklist: true, itChecklist: true, esChecklist: true, ptChecklist: true, cnsChecklist: true, cntChecklist: true},
  {code: 'ody', enChecklist: true, deChecklist: true},
  {code: 'apc', enChecklist: true},
  {code: '7ed', enChecklist: true},
  {code: 'pls', enChecklist: true},
  {code: 'inv', enChecklist: true},
  {code: 'pcy', enChecklist: true},
  {code: 'nem', enChecklist: true},
  {code: 'mmq', enChecklist: true},
  {code: 'uds', enChecklist: true, notes: "combined with Urza's Legacy"},
  {code: '6ed', enChecklist: false, notes: "it existed: https://web.archive.org/web/20141017015534/http://wpn.wizards.com:80/en/resources/rules-documents/all/checklist?keys=&tid_1=All&field_document_type_value=All&field_product_target_id=All&sort_by=changed&page=1"},
  {code: 'ulg', enChecklist: true, notes: "combined with Urza's Destiny"},
  {code: 'usg', enChecklist: true},
  {code: 'exo', enChecklist: true},
  {code: 'sth', enChecklist: true},
  {code: 'tmp', enChecklist: true},
  {code: 'wth', enChecklist: true},
  {code: '5ed', enChecklist: true},
  {code: 'vis', enChecklist: true},
  {code: 'mir', enChecklist: true}
];

@Component({
  selector: 'app-checklist-table',
  templateUrl: './checklist-table.component.html',
  styleUrls: ['./checklist-table.component.scss']
})
export class ChecklistTableComponent implements OnInit {

  setsData: SetDataScryfall[] = []; 
  constructor(private setsService : GetSetsService) { 
  }

  displayedColumns: string[] = ['edition', 'symbol', 'releaseDate','checklists'];
  checklistDataSource: SetDataScryfall[] = [];

  checklistCount = 0;
  
  ngOnInit(): void {
    this.setsService.getSets().subscribe(
      result => {
        this.checklistDataSource = result.data.filter((set:SetDataScryfall) => {return this.filterSet(set);});
        this.checklistDataSource = this.mergeChecklists(this.checklistDataSource, checklistDataArray)
      }
    )

    this.checklistCount = Object.values(checklistDataArray).filter(element => element.enChecklist === true).length +
                      Object.values(checklistDataArray).filter(element => element.deChecklist === true).length +    
                      Object.values(checklistDataArray).filter(element => element.frChecklist === true).length +    
                      Object.values(checklistDataArray).filter(element => element.esChecklist === true).length +    
                      Object.values(checklistDataArray).filter(element => element.itChecklist === true).length +    
                      Object.values(checklistDataArray).filter(element => element.ptChecklist === true).length +    
                      Object.values(checklistDataArray).filter(element => element.jpChecklist === true).length +    
                      Object.values(checklistDataArray).filter(element => element.cnsChecklist === true).length +    
                      Object.values(checklistDataArray).filter(element => element.cntChecklist === true).length +
                      Object.values(checklistDataArray).filter(element => element.krChecklist === true).length +
                      Object.values(checklistDataArray).filter(element => element.ruChecklist === true).length   
  }

  mergeChecklists (sets: SetDataScryfall[], checklists: checklistEntry[]) {
    const map = new Map();
    this.checklistDataSource.forEach(item => map.set(item.code, item));
    checklistDataArray.forEach(item => map.set(item.code, {...map.get(item.code), ...item}));
    const mergedArr = Array.from(map.values());
    return mergedArr;
  }

  filterSet(data: SetDataScryfall){
    const now = new Date();
    const releasedDate = new Date(data.released_at);

    // exceptions like The List, Timeshifted etc
    if (data.code === "plst" || data.code === "fmb1" || data.code === "tsb" || data.code === "cmr"
        || data.code === "mat" || data.code === "slx" || data.code === "mb1" || data.code === "cmm"
        || data.code === "sum" || data.code === "4bb" || data.code === "rin" || data.code === "bchr"
        || data.code === "big" || data.code === "mb2" ) {
      return false;
    } else if (data.code === "ltr" || data.code === "mh1" || data.code === "mh2"  || data.code === "mh3" || data.code === "clb") {
      return true;
    }

    if (releasedDate > now) {
      return false;
    }

    const result = (data.set_type === "masters" || data.set_type === "core" || data.set_type === "expansion") && !data.digital;

    return result;
  }

}
